import { useStyles } from '../styles';
import { Box, CircularProgress, Typography } from '@material-ui/core';

interface LoadingStateProps {
  primaryText: string;
  secondaryText?: string;
}

export function LoadingState({
  primaryText,
  secondaryText,
}: LoadingStateProps) {
  const classes = useStyles();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      py={8}
      gridGap={secondaryText ? 8 : undefined}
    >
      <CircularProgress size={48} className={classes.indexLoadingSpinner} />
      <Typography variant="h6" className={classes.indexAnalysingText}>
        {primaryText}
      </Typography>
      {secondaryText && (
        <Typography variant="body2" className={classes.indexReportInfoText}>
          {secondaryText}
        </Typography>
      )}
    </Box>
  );
}
